import React, { useState, useEffect, useContext } from "react";
import { Container } from "@mui/material";
import { delay, getData } from "../../../components/utilities/UtilityFunctions";
import DashboardBuilder from "../../stats/components/DashboardBuilder";
import { AuthContext } from "../../../components/user/BCPAuthProvider";
import SubscribeBanner from "../../../components/layout/SubscribeBanner";
import ModalLoadingMessage from "../../../components/modals/ModalLoadingMessage";

const loadingMessages = [
  "Establishing Forward Recon",
  "Scanning the Battlefield",
  "Acquiring Tactical Intelligence",
  "Identifying Enemy Positions",
  "Calculating Attack Vectors",
  "Assigning Strike Teams",
  "Synchronizing Combat Data",
  "Deploying Recon Drones",
  "Locking Target Coordinates",
  "Updating Mission Parameters",
  "Analyzing Enemy Formations",
  "Confirming Fire Support",
  "Establishing Command Uplink",
  "Evaluating Strategic Assets",
  "Preparing Tactical Briefing"
].sort(() => Math.random() - 0.5);

export default function EventStats(props) {
  const { event } = props;
  const authContext = useContext(AuthContext);
  const [stats, setStats] = useState(null);
  const [message, setMessage] = useState(0);

  const fetchStats = async () => {
    let apiData = await getData("/stats", {
      queryStringParameters: {
        eventId: event?.id
      }
    });

    setStats(apiData);
    return apiData;
  };

  const loadData = async () => {
    let apiData = await fetchStats();
    while (apiData?.status !== "Completed") {
      await delay(2000);
      setMessage(message + 1);
      await delay(1000);
      setMessage(message + 1);

      apiData = await fetchStats();
    }
    setMessage(-1);
  };

  useEffect(() => {
    if (event?.id) {
      loadData();
    }
  }, [event?.id]);

  if (!stats?.rows || message >= 0) {
    return (
      <Container
        maxWidth="lg"
        sx={{
          pt: 2,
          pb: 2,
          px: { xs: "10%", sm: "6%", md: 3 },
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "400px"
        }}
      >
        <ModalLoadingMessage message={loadingMessages[message || 0]} open />
      </Container>
    );
  }

  return (
    <>
      {!authContext?.authState?.identity?.subscriber && (
        <Container
          maxWidth="lg"
          sx={{
            pt: 2,
            pb: 2,
            px: { xs: "10%", sm: "6%", md: 3 }
          }}
        >
          <SubscribeBanner href="/subscription" />
        </Container>
      )}
      <Container maxWidth="lg" sx={{ px: { xs: "10%", sm: "6%", md: 3 } }}>
        <DashboardBuilder rows={stats.rows} eventName={event?.name} />
      </Container>
    </>
  );
}
